<h2>Подтвердите удаление</h2>
<div class="wrapper">
  <button mat-flat-button color="primary" (click)="confirm()">Подтверждаю</button>
  <button mat-flat-button color="warn" (click)="decline()">Отклониить</button>
</div>
